import React from 'react'
import { pick } from 'lodash-es'
import { useTbViewStore } from '@vt/hooks'
import { Calendar } from '@ow/ditto'

export default ({ showTbDetail, createTbData }) => {
  const { fields, tbData, currentDate } = useTbViewStore((state) =>
    pick(state, ['fields', 'tbData', 'currentDate'])
  )

  return (
    <div
      className="w-full flex-1 overflow-y-auto h-full"
      style={{ height: '500px' }}
    >
      <Calendar
        currentDate={currentDate}
        tbData={tbData}
        showTbDetail={(data) => {
          showTbDetail(data, fields)
        }}
        // onClickOpenCreate={() => {
        //   openDittoForm({}, fields)
        // }}
        createTbData={() => {
          createTbData({}, fields)
        }}
      />
    </div>
  )
}
